// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-dashboard {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.admin-header {
  margin-bottom: 30px;
}

.admin-header h1 {
  margin: 0 0 8px;
  color: #333;
  font-size: 28px;
}

.admin-header p {
  margin: 0;
  color: #666;
}

.admin-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
}

.tab {
  padding: 10px 20px;
  background: none;
  border: none;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s;
}

.tab:hover {
  background: #f5f5f5;
  color: #333;
}

.tab.active {
  background: #667eea;
  color: white;
}

.admin-content {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.stat-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px;
  border-radius: 12px;
  text-align: center;
}

.stat-card h3 {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.9;
}

.stat-card .stat-value {
  margin: 0;
  font-size: 36px;
  font-weight: 700;
}

.users-table h2,
.meetings-table h2,
.settings-form h2 {
  margin: 0 0 20px;
  color: #333;
  font-size: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

th {
  font-weight: 600;
  color: #666;
  font-size: 12px;
  text-transform: uppercase;
}

td select {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.active,
.status-badge.scheduled {
  background: #d4edda;
  color: #155724;
}

.status-badge.inactive,
.status-badge.cancelled {
  background: #f8d7da;
  color: #721c24;
}

.status-badge.in-progress {
  background: #fff3cd;
  color: #856404;
}

.status-badge.completed {
  background: #cce5ff;
  color: #004085;
}

.btn-small {
  padding: 6px 12px;
  margin-right: 8px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}

.btn-small.btn-danger {
  background: #dc3545;
}

.btn-small:hover {
  opacity: 0.9;
}

.settings-form form {
  max-width: 500px;
}

.settings-form .form-group {
  margin-bottom: 20px;
}

.settings-form .form-group.checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
}

.settings-form .form-group.checkbox input {
  width: auto;
}

.settings-form .form-group.checkbox label {
  margin: 0;
}

.settings-form .form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

.settings-form .form-group input[type="number"] {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.error-message {
  background: #fee;
  border: 1px solid #fcc;
  color: #c33;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.admin-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
  color: #666;
}

.rooms-table h2 {
  margin: 0 0 20px;
  color: #333;
  font-size: 20px;
}

.rooms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}

.rooms-loading,
.rooms-empty {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

.room-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.room-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.room-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.room-card h3 {
  margin: 0;
  color: #1a1a2e;
  font-size: 18px;
  font-weight: 600;
  flex: 1 1;
  word-break: break-word;
}

.room-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.room-status-badge.active {
  background: #d4edda;
  color: #155724;
}

.room-status-badge.inactive {
  background: #f8d7da;
  color: #721c24;
}

.room-status-badge::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
}

.room-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.room-info-item {
  display: flex;
  justify-content: space-between;
}

.room-info-label {
  font-weight: 500;
  color: #888;
}

.room-info-value {
  color: #333;
}

.room-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.room-actions .btn-small {
  flex: 1 1;
  min-width: 90px;
  padding: 8px 12px;
  font-size: 13px;
}

.room-actions .btn-danger {
  background: #fee;
  color: #dc3545;
  border: 1px solid #fcc;
}

.room-actions .btn-danger:hover {
  background: #fdd;
}

@media (max-width: 768px) {
  .rooms-grid {
    grid-template-columns: 1fr;
  }
  
  .room-card {
    padding: 16px;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 400px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.modal-header .close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
}

.modal-header .close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 24px;
}

.modal-body p {
  margin: 0 0 16px;
  color: #666;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #eee;
}

.btn-secondary {
  padding: 8px 16px;
  background: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 6px;
  color: #333;
  font-size: 14px;
  cursor: pointer;
}

.btn-secondary:hover {
  background: #e5e5e5;
}

@media (max-width: 768px) {
  .admin-tabs {
    flex-wrap: wrap;
  }

  .tab {
    padding: 8px 12px;
    font-size: 12px;
  }

  table {
    font-size: 12px;
  }

  th, td {
    padding: 8px;
  }

  .btn-small {
    padding: 4px 8px;
    font-size: 10px;
    margin-right: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AdminDashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".admin-dashboard {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n}\r\n\r\n.admin-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.admin-header h1 {\r\n  margin: 0 0 8px;\r\n  color: #333;\r\n  font-size: 28px;\r\n}\r\n\r\n.admin-header p {\r\n  margin: 0;\r\n  color: #666;\r\n}\r\n\r\n.admin-tabs {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-bottom: 20px;\r\n  border-bottom: 2px solid #eee;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.tab {\r\n  padding: 10px 20px;\r\n  background: none;\r\n  border: none;\r\n  color: #666;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  border-radius: 8px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.tab:hover {\r\n  background: #f5f5f5;\r\n  color: #333;\r\n}\r\n\r\n.tab.active {\r\n  background: #667eea;\r\n  color: white;\r\n}\r\n\r\n.admin-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.overview-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n.stat-card {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  padding: 24px;\r\n  border-radius: 12px;\r\n  text-align: center;\r\n}\r\n\r\n.stat-card h3 {\r\n  margin: 0 0 10px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  opacity: 0.9;\r\n}\r\n\r\n.stat-card .stat-value {\r\n  margin: 0;\r\n  font-size: 36px;\r\n  font-weight: 700;\r\n}\r\n\r\n.users-table h2,\r\n.meetings-table h2,\r\n.settings-form h2 {\r\n  margin: 0 0 20px;\r\n  color: #333;\r\n  font-size: 20px;\r\n}\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\nth, td {\r\n  padding: 12px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\nth {\r\n  font-weight: 600;\r\n  color: #666;\r\n  font-size: 12px;\r\n  text-transform: uppercase;\r\n}\r\n\r\ntd select {\r\n  padding: 6px 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n}\r\n\r\n.status-badge {\r\n  display: inline-block;\r\n  padding: 4px 10px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status-badge.active,\r\n.status-badge.scheduled {\r\n  background: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.status-badge.inactive,\r\n.status-badge.cancelled {\r\n  background: #f8d7da;\r\n  color: #721c24;\r\n}\r\n\r\n.status-badge.in-progress {\r\n  background: #fff3cd;\r\n  color: #856404;\r\n}\r\n\r\n.status-badge.completed {\r\n  background: #cce5ff;\r\n  color: #004085;\r\n}\r\n\r\n.btn-small {\r\n  padding: 6px 12px;\r\n  margin-right: 8px;\r\n  background: #667eea;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-small.btn-danger {\r\n  background: #dc3545;\r\n}\r\n\r\n.btn-small:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n.settings-form form {\r\n  max-width: 500px;\r\n}\r\n\r\n.settings-form .form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.settings-form .form-group.checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.settings-form .form-group.checkbox input {\r\n  width: auto;\r\n}\r\n\r\n.settings-form .form-group.checkbox label {\r\n  margin: 0;\r\n}\r\n\r\n.settings-form .form-group label {\r\n  display: block;\r\n  margin-bottom: 8px;\r\n  color: #333;\r\n  font-weight: 500;\r\n}\r\n\r\n.settings-form .form-group input[type=\"number\"] {\r\n  width: 100%;\r\n  padding: 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n}\r\n\r\n.error-message {\r\n  background: #fee;\r\n  border: 1px solid #fcc;\r\n  color: #c33;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.admin-loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100vh;\r\n  font-size: 18px;\r\n  color: #666;\r\n}\r\n\r\n.rooms-table h2 {\r\n  margin: 0 0 20px;\r\n  color: #333;\r\n  font-size: 20px;\r\n}\r\n\r\n.rooms-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n.rooms-loading,\r\n.rooms-empty {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #666;\r\n  font-size: 16px;\r\n}\r\n\r\n.room-card {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n  border: 1px solid #f0f0f0;\r\n  transition: all 0.3s ease;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.room-card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.room-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n}\r\n\r\n.room-card h3 {\r\n  margin: 0;\r\n  color: #1a1a2e;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  flex: 1;\r\n  word-break: break-word;\r\n}\r\n\r\n.room-status-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 10px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.room-status-badge.active {\r\n  background: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.room-status-badge.inactive {\r\n  background: #f8d7da;\r\n  color: #721c24;\r\n}\r\n\r\n.room-status-badge::before {\r\n  content: '';\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: currentColor;\r\n}\r\n\r\n.room-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.room-info-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.room-info-label {\r\n  font-weight: 500;\r\n  color: #888;\r\n}\r\n\r\n.room-info-value {\r\n  color: #333;\r\n}\r\n\r\n.room-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.room-actions .btn-small {\r\n  flex: 1;\r\n  min-width: 90px;\r\n  padding: 8px 12px;\r\n  font-size: 13px;\r\n}\r\n\r\n.room-actions .btn-danger {\r\n  background: #fee;\r\n  color: #dc3545;\r\n  border: 1px solid #fcc;\r\n}\r\n\r\n.room-actions .btn-danger:hover {\r\n  background: #fdd;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .rooms-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .room-card {\r\n    padding: 16px;\r\n  }\r\n}\r\n\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\r\n  width: 90%;\r\n  max-width: 400px;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px 24px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.modal-header h3 {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 18px;\r\n}\r\n\r\n.modal-header .close-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  color: #666;\r\n}\r\n\r\n.modal-header .close-btn:hover {\r\n  color: #333;\r\n}\r\n\r\n.modal-body {\r\n  padding: 24px;\r\n}\r\n\r\n.modal-body p {\r\n  margin: 0 0 16px;\r\n  color: #666;\r\n}\r\n\r\n.modal-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  padding: 16px 24px;\r\n  border-top: 1px solid #eee;\r\n}\r\n\r\n.btn-secondary {\r\n  padding: 8px 16px;\r\n  background: #f5f5f5;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  color: #333;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: #e5e5e5;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .admin-tabs {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .tab {\r\n    padding: 8px 12px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  table {\r\n    font-size: 12px;\r\n  }\r\n\r\n  th, td {\r\n    padding: 8px;\r\n  }\r\n\r\n  .btn-small {\r\n    padding: 4px 8px;\r\n    font-size: 10px;\r\n    margin-right: 4px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
